// src/utils/firebase/uploadMetadata.ts
import { getStorage, ref as storageRef, uploadString } from "firebase/storage";
import { firebaseApp } from "../../firebase/firebaseApp";

/**
 * Persist a form-answers object as a JSON file in Cloud Storage.
 *
 * Path: user_metadata/{uid}/{ISO-timestamp}-{5rnd}.json
 *
 * @param {string} uid          – Firebase Auth UID
 * @param {object} answers      – Key⇢value map of the form answers
 * @returns {Promise<string>}   – The gs:// URL that was written
 */
export async function uploadMetadata(uid, answers) {
  if (!uid) throw new Error("uploadMetadata: uid missing");
  if (typeof answers !== "object")
    throw new Error("uploadMetadata: answers must be an object");

  /* Build filename: 2025-06-26T17-43-10Z-n36kf.json */
  const iso = new Date().toISOString().replace(/:/g, "-");
  const rand = Math.random().toString(36).slice(2, 7); // 5 chars
  const fileName = `${iso}-${rand}.json`;

  /* Upload */
  const storage = getStorage(firebaseApp);
  const fileRef = storageRef(storage, `user_metadata/${uid}/${fileName}`);

  await uploadString(fileRef, JSON.stringify(answers), "raw", {
    contentType: "application/json",
  });

  return fileRef.toString();
}
